import React, { Component } from 'react'
import { Row, Col, Form, Upload, InputNumber, Button, DatePicker, Input, Select, Modal, Icon, Popover } from 'antd'
import { app, api, config } from '../../app'
import moment from 'moment'
import reqwest from 'reqwest'
import Cropper from 'react-cropper'
import default_img from '../../assets/head_default_img.png'
import head_example from '../../assets/head_example.jpg'
import 'moment/locale/zh-cn'
import 'cropperjs/dist/cropper.css'

moment.locale('zh-cn')

const FormItem = Form.Item
const Option = Select.Option
const TextArea = Input.TextArea

/**
 * 根据base64 内容 取得 bolb
 * @param dataURI
 * @param type
 * @returns {Blob}
 */
function getBlobBydataURI(dataurl) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], 'photo.png', { type: mime })
}


function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
}

class InfoEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            avatarUrl: '',
            account: app.getData('account'),
            indexno: app.getData('indexno'),
            data_loading: true,
            update_loading: false,
            img_path: '',
            localpath: '',
            local_img: '',
            last_img: '',
            vname: '',
            userInfo: {},
            politicsList: [],
            bloodtypeList: [],
        }
        this.dataSource()
    }

    componentDidMount() {
        this._isMounted = true
        this.politicsSource()
        this.bloodtypeSource()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据源
     */
    async dataSource() {
        app.alert('正在加载数据...', 'loading', '35%', 0)
        const params = { indexno: this.state.indexno, account: this.state.account }
        let { flag, data, msg } = await app.post(api.UserBasicInfo, params)
        app.alertDestroy()
        const state = { data_loading: false }
        if (flag === 1) {
            state.localpath = data.localpath ? (config.imgUrl + app.urlEncode(data.localpath)) : default_img
            state.vname = data.vname
            state.img_path = data.localpath
            state.userInfo = data
        } else {
            app.alert(msg, "error")
        }
        this.setData(state)
        this.props.form.resetFields()
    }

    /**
     * 政治面貌数据源
     */
    async politicsSource() {
        let { flag, data, msg } = await app.post(api.UPoliticsSelectLists)
        const state = {}
        if (flag === 1) {
            state.politicsList = data
        } else {
            app.alert(msg, "error")
        }
        this.setData(state)
        await this.handlePoliticsChange(this.state.userInfo.politics || [])
    }

    /**
     * 血型数据源
     */
    async bloodtypeSource() {
        const params = {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
        }
        let { flag, data, msg } = await app.post(api.UBloodtypeSelectLists, params)
        const state = {}
        if (flag === 1) {
            state.bloodtypeList = data
        } else {
            app.alert(msg, "error")
        }
        this.setData(state)
    }

    /**
     * 提交信息
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                const _this = this, update_loading = this.state.update_loading
                if (update_loading) return false
                await this.setData({ update_loading: true })
                values.url = this.state.img_path
                if (!values.url) {
                    app.alert("请上传您的头像照片", 'error')
                    return
                }
                values.token = app.getToken()
                values.indexno = this.state.indexno
                values.account = this.state.account

                values.bloodtype = values.bloodtype || ''
                values.politics_id = values.politics_id.join(',')
                values.birthdate = moment(values.birthdate).format("YYYY-MM-DD")
                const { flag, msg } = await app.post(api.UserInfoEdit, values)
                if (flag === 1) {
                    app.alert("修改成功~", "success")
                } else {
                    app.alert(msg, "error")
                }
                this.setData({ update_loading: false })
            }
        })
    }

    /**
     * 展示图片
     * @param file
     */
    handlePreview = () => {

    }

    handleUploadChange = (info) => {
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                getBase64(info.file.originFileObj, imageUrl => {
                    app.alert("更改成功", "success")
                    this.setData({ localpath: imageUrl, img_path: res.data.url })
                })
            } else {
                app.alert(res.msg || '上传错误', "error")
            }
        }
    }

    /**
     * 确认头像选择
     */
    handleConfirmHead = async () => {
        let last_img = this.refs.cropper.getCroppedCanvas().toDataURL()
        console.log(last_img)
        let formData = new FormData()
        formData.append('token', app.getToken())
        formData.append('indexno', app.getData('indexno'))
        formData.append('account', app.getData('account'))
        formData.append('upload_type', 'photo')
        formData.append('image', getBlobBydataURI(last_img))
        // let formData = {
        //     indexno: app.getData('indexno'),
        //     account: app.getData('account'),
        //     upload_type: 'photo',
        //     image: getBlobBydataURI(last_img),
        // };
        let options = {
            url: config.serverUrl + api.ImageUpload,
            method: 'post',
            processData: false,
            data: formData,
            success: async ({ flag, data, msg }) => {
                console.log(flag, data, msg)
                if (flag === 1) {
                    await this.setData({
                        localpath: config.imgUrl + data.url,
                        head_visible: false,
                        local_img: '',
                        last_img: ''
                    })
                } else {
                    app.alert(msg, 'warn')
                }
            },
            error: () => {
                app.alert('上传失败', 'warn')
            }
        }
        reqwest(options)
    }

    /**
     * 取消头像选择
     */
    handleCancelHead = async () => {
        await this.setData({ head_visible: false, local_img: '', last_img: '' })
    }

    /**
     * 上传之前
     * @param file
     * @returns {boolean}
     */
    beforeUpload = (file) => {
        let isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
            app.alert("请上传2MB以下照片！", "warn")
        } else {
            getBase64(file, local_img => this.setData({ local_img, head_visible: true }))
        }
        return false
    }

    /**
     * 政治面貌变更
     * @param value
     * @returns {Promise<void>}
     */
    handlePoliticsChange = async (value) => {
        const { politicsList } = this.state
        let politicsList2 = []
        if (value.length === 0) {
            politicsList2 = politicsList.map(p => {
                p.disabled = false
                return p
            })
        } else if (value.length === 1) {
            let item = politicsList.filter(p => p.value === value[0])[0]
            if (item.type === '1') {
                politicsList2 = politicsList.map(p => {
                    if (p.value !== value[0] && (p.type === '1' || p.type === '0')) {
                        p.disabled = true
                    } else {
                        p.disabled = false
                    }
                    return p
                })
            } else if (item.type === '2') {
                politicsList2 = politicsList.map(p => {
                    if (p.value !== value[0] && (p.type === '2' || p.type === '0')) {
                        p.disabled = true
                    } else {
                        p.disabled = false
                    }
                    return p
                })
            } else {
                politicsList2 = politicsList.map(p => {
                    if (p.value === value[0]) {
                        p.disabled = false
                    } else {
                        p.disabled = true
                    }
                    return p
                })
            }
        } else {
            console.log(value)
            politicsList2 = politicsList.map(p => {
                if (value[0] !== p.value && value[1] !== p.value) {
                    p.disabled = true
                } else {
                    p.disabled = false
                }
                return p
            })
            console.log(politicsList2)
        }
        await this.setData({ politicsList: politicsList2 })
    }

    render() {
        let formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 10, offset: 1 },
        },
            { getFieldDecorator } = this.props.form,
            { data_loading, head_visible, update_loading, userInfo, localpath, vname, local_img, politicsList, bloodtypeList } = this.state
        const content4 = (
            <div>
                <p>
                    生日填写须知：<br/>
                    比如您填写的生日是 1996-02-26，平台生日祝福推送方式如下（2021年为例）：<br/>
                    1、按新历推送：2021-02-26 推送生日祝福短信<br/>
                    2、按农历推送：2021-04-07（农历二月廿十六）推送生日祝福短信<br/>
                    3、新历农历都推送：2021-02-26和2021-04-07都会推送生日祝福短信<br/>
                    <br/>
                    注：生日祝福短信推送方式由各队管理员设置<br/>
                </p>
            </div>
        )

        return (
            <div className="member-page info-edit">
                <div className="member-page-title">个人信息编辑</div>
                <Row className="mp-content">
                    <Form onSubmit={this.handleSubmit}>
                        <Col span={24} className="title">修改个人信息<span>（以下编辑的信息如果不想修改可以不填写）</span></Col>
                        <Col span={24}>
                            <Row className="portrait item" type="flex" align="top">
                                <Col span={4} style={{ textAlign: 'right' }}
                                    className="ant-form-item-required">个人照片:</Col>
                                <Col style={{ width: 120, textAlign: 'center' }} offset={1}>
                                    <Upload
                                        accept='image/jpeg, image/jpg, image/png'
                                        showUploadList={false}
                                        beforeUpload={this.beforeUpload}
                                        className="avatar-img"
                                    >
                                        {
                                            localpath ?
                                                (<img src={localpath} alt="" className="avatar" />) :
                                                (<Button className="avatar-uploader-trigger" size="small"
                                                    disabled={data_loading}>更改头像</Button>)
                                        }
                                    </Upload>

                                </Col>
                                <Col span={12} offset={2} style={{ textAlign: 'left' }}>
                                    <img src={head_example} alt="" className="example" />
                                </Col>
                                <Col offset={4} className="zhu">
                                    <div><span className="zhu1">注：白底免冠大一寸彩照，着装要求：蓝色队服。</span></div>
                                    <div><span className="zhu2">点击图片更换头像 | 图片比例建议：宽/高=0.74左右：200KB以内</span></div>
                                </Col>
                            </Row>
                            {1 === 0 ? <Row className="username item" type="flex">
                                <Col span={2} style={{ textAlign: 'right' }}>修改姓名:</Col>
                                <Col span={10} offset={1}>
                                    <Col span={12}><Input placeholder="请填写您的真实姓名" value={vname} /></Col>
                                    <Col span={24}>
                                        <Row className="idcar" type="flex">
                                            <Row className="idcar-item">
                                                <img src={default_img} alt="" className="idcar-pic" />
                                                <Upload
                                                    accept='image/jpeg, image/jpg, image/png'
                                                    showUploadList={false}
                                                    beforeUpload={this.beforeUpload}
                                                    action={config.serverUrl + api.ImageUpload}
                                                    data={{
                                                        indexno: app.getData('indexno'),
                                                        account: app.getData('account'),
                                                        token: app.getData('token'),
                                                        upload_type: 'photo',
                                                    }}
                                                    name="image"
                                                    onPreview={this.handlePreview}
                                                    onChange={this.handleUploadChange}
                                                    className="idcar-img"
                                                >
                                                    <Button className="avatar-uploader-trigger" disabled={data_loading}
                                                        size="small">上传有效身份证正面</Button>
                                                </Upload>
                                            </Row>
                                            <Row className="idcar-item">
                                                <img src={default_img} alt="" className="idcar-pic" />
                                                <Upload
                                                    accept='image/jpeg, image/jpg, image/png'
                                                    action={config.serverUrl + api.PortraitUpload}
                                                    showUploadList={false}
                                                    beforeUpload={this.beforeUpload}
                                                    data={{
                                                        indexno: app.getData('indexno'),
                                                        account: app.getData('account'),
                                                        token: app.getData('token')
                                                    }}
                                                    name="portrait"
                                                    onPreview={this.handlePreview}
                                                    onChange={this.handleUploadChange}
                                                    className="idcar-img"
                                                >
                                                    <Button className="avatar-uploader-trigger" disabled={data_loading}
                                                        size="small">上传有效身份证反面</Button>
                                                </Upload>
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row> : ''}
                            <Row className="item">
                                <FormItem
                                    {...formItemLayout}
                                    label="代号"
                                >
                                    {getFieldDecorator('nickname', { initialValue: userInfo.nickname || '' })(
                                        <Input placeholder="请填写您的新代号" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="家庭电话"
                                >
                                    {getFieldDecorator('hometel', { initialValue: userInfo.hometel || '' })(
                                        <Input placeholder="请填写您的家庭电话" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="家庭地址"
                                >
                                    {getFieldDecorator('homeaddr', { initialValue: userInfo.homeaddr || '' })(
                                        <Input placeholder="请填写您的家庭地址" />
                                    )}
                                </FormItem>
                                {/* <FormItem
                                    {...formItemLayout}
                                    label="收货地址"
                                >
                                    {getFieldDecorator('malladdr', { initialValue: userInfo.malladdr || '' })(
                                        <Input placeholder="请填写您的收货地址" />
                                    )}
                                </FormItem> */}
                                <FormItem
                                    {...formItemLayout}
                                    label="电子邮箱"
                                >
                                    {getFieldDecorator('email', { initialValue: userInfo.email || '' })(
                                        <Input placeholder="请填写您的电子邮件" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="出生年月"
                                >
                                    {getFieldDecorator('birthdate', {
                                        ...(userInfo.birthdate ? { initialValue: moment(userInfo.birthdate) } : {}),
                                        rules: [{ required: true, message: '请选择您的生日!' }]
                                    })(
                                        <DatePicker placeholder="请选择您的生日" />
                                    )}

                                    <Popover content={content4} >

                                        <Icon type="question-circle" style={{ color: 'grey', fontSize: 14, marginLeft: 10 }} />
                                    </Popover>

                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="添加护照号"
                                >
                                    {getFieldDecorator('passport', { initialValue: userInfo.passport || '' })(
                                        <Input placeholder="请填写您的护照号" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="身高(cm)"
                                >
                                    {getFieldDecorator('height', { initialValue: userInfo.height || '' })(
                                        <InputNumber max={300} precision={2} placeholder="身高" />
                                    )}
                                    <span className='item-suffix'>cm</span>
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="体重(kg)"
                                >
                                    {getFieldDecorator('weight', { initialValue: userInfo.weight || '' })(
                                        <InputNumber max={500} precision={2} placeholder="体重" />
                                    )}
                                    <span className='item-suffix'>kg</span>
                                </FormItem>
                                <FormItem
                                    label="血型"
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 4, offset: 1 }}
                                >
                                    {getFieldDecorator('bloodtype', { ...(userInfo.bloodtype ? { initialValue: userInfo.bloodtype } : {}) })(
                                        <Select style={{ width: '60%' }} placeholder="请填写您的血型">
                                            {
                                                bloodtypeList.map(b => {
                                                    return (
                                                        <Option key={b.value} value={b.value}>{b.title}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="紧急联系人"
                                >
                                    {getFieldDecorator('emecontact', {
                                        initialValue: userInfo.emecontact || '',
                                        rules: [{ required: true, message: '请输入紧急联系人姓名!' }]
                                    })(
                                        <Input placeholder="请输入紧急联系人姓名" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="紧急联系人电话"
                                >
                                    {getFieldDecorator('emecontactphone', {
                                        initialValue: userInfo.emecontactphone || '',
                                        rules: [{ required: true, message: '请输入紧急联系人电话!' }]
                                    })(
                                        <Input placeholder="请输入紧急联系人电话" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="过敏史"
                                >
                                    {getFieldDecorator('drughis', { initialValue: userInfo.drughis || '' })(
                                        <TextArea placeholder="请填写您的过敏史" autosize={{ maxRows: 6 }}
                                            style={{ width: 'calc(100% - 120px)' }} />
                                    )}
                                    <span className='item-suffix s_red'>请务必真实填写</span>
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="重大病史"
                                >
                                    {getFieldDecorator('medicalhis', { initialValue: userInfo.medicalhis || '' })(
                                        <TextArea placeholder="请填写您的重大病史" autosize={{ maxRows: 6 }}
                                            style={{ width: 'calc(100% - 120px)' }} />
                                    )}
                                    <span className='item-suffix s_red'>请务必真实填写</span>
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="政治面貌"
                                >
                                    {getFieldDecorator('politics_id', {
                                        initialValue: userInfo.politics || [],
                                        rules: [{ required: true, message: '请选择政治面貌!' }]
                                    })(
                                        <Select placeholder="请选择政治面貌" mode="multiple"
                                            onChange={this.handlePoliticsChange}>
                                            {
                                                politicsList.map(p => {
                                                    return (
                                                        <Option key={p.value} value={p.value}
                                                            disabled={p.disabled}>{p.title}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    wrapperCol={{ span: 10, offset: 3 }}
                                >
                                    <Button type="primary" htmlType="submit" disabled={data_loading}
                                        loading={update_loading}>提交</Button>
                                </FormItem>
                            </Row>
                        </Col>
                    </Form>
                </Row>
                <Modal
                    title="照片裁剪"
                    visible={head_visible}
                    onOk={this.handleConfirmHead}
                    onCancel={this.handleCancelHead}
                    destroyOnClose={true}
                    className="pic-cropper-modal"
                    okText="确定"
                    cancelText="取消"
                >
                    <Cropper
                        ref='cropper'
                        src={local_img}
                        style={{ height: 400, width: '100%' }}
                        aspectRatio={0.75}
                        guides={false}
                        disable={true}
                        cropBoxData={{
                            width: 133.2,
                            height: 180,
                            top: 0,
                            left: 0,
                        }} />
                </Modal>
            </div>
        )
    }
}

export default Form.create()(InfoEdit)



// WEBPACK FOOTER //
// ./src/routes/playerInfo/InfoEdit.jsx